import React, { useState, useEffect } from 'react';
import {  AppBar, Toolbar, Typography, Box , Grid, Button, Menu, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LeftDrawer from '../components/LeftDrawer';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate  } from 'react-router-dom'; 
import axiosInstance from '../common/axios';

const PurchaseOrderList = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
    
      const navigate = useNavigate(); 
      const { user } = useAuth();
        const { email, name, userId, roles, userTypes} =  user || {};

  useEffect(() => {
    // Fetch purchase orders from the API
    const fetchPurchaseOrders = async () => {
      try {
        const response = await axiosInstance.get('/api/purchase-orders/summary');
        setPurchaseOrders(response.data);
        setFilteredOrders(response.data);
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
      }
    };
      
       const fetchPurchaseOrderStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/purchase-orders/status');
        setStatusOptions(response.data);
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
      }
    };
      
    fetchPurchaseOrders();
      fetchPurchaseOrderStatus();
  }, []);

  // Filter orders based on status and search term
  useEffect(() => {
    const filtered = purchaseOrders.filter((order) =>
      (statusFilter ? order.poStatus === statusFilter : true) &&
      (searchTerm ? order.poUniqueId.toLowerCase().includes(searchTerm.toLowerCase()) : true)
    );
    setFilteredOrders(filtered);
  }, [statusFilter, searchTerm, purchaseOrders]);

  // Handle status update 
  const handleStatusUpdate = async (orderId, statusId) => {
      console.log("newStatus "+statusId);
    try {
      await axiosInstance.put(`/api/purchase-orders/${orderId}/status?statusId=${statusId}&userId=${userId}`);
     /* setPurchaseOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? { ...order, status: newStatus } : order
        )
      ); */
      setStatusAnchorEl(null);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // Column definitions for DataGrid
  const columns = [
    { field: 'poUniqueId', headerName: 'PO Number', width: 150 },
    { field: 'createdDate', headerName: 'Created Date', width: 180 },
    { field: 'updatedDate', headerName: 'Updated Date', width: 180 },
    { field: 'vendorContactName', headerName: 'Vendor', width: 150 },
    { field: 'shiptoContactName', headerName: 'Supplier', width: 150 },
    { field: 'poStatus', headerName: 'Status', width: 150 },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          onClick={(event) => {
            setStatusAnchorEl(event.currentTarget);
            setSelectedOrderId(params.row.id);
          }}
        >
          Update Status
        </Button>
      ),
    },
  ];


  // Navigation handlers for the menu items
  const handleRequestQuote = () => navigate('/request-quote');
  const handleQuoteList = () => navigate('/quote-list');
  const handleOrders = () => navigate('/orders');
     const handleTracker = () => navigate('/tracker');
    
      const handleDealer = () => navigate('/dealerreg');
      const handleDealers = () => navigate('/dealers');
     
  const handleSupplier = () => navigate('/suppliereg');
      const handleSuppliers = () => navigate('/suppliers');
     const handleManufacturer = () => navigate('/manufacturerreg');
    
     const handleManufacturers = () => navigate('/manufacturers');
    
      const handleDashboard = () => navigate('/dashboard');
    
   const handleProfile = () => navigate('/profile');
    const handlePurchaseOrder = () => navigate('/purchaseorder')
    const handleSendEstimate = () => navigate('/send-estimate')
    const handleEstimate = () => navigate('/estimate')
   const handlePartner = () => navigate('/partner')
      const handleInvoice = () => navigate('/invoice')
      const handleTrader = () => navigate('/trader')
        const handleBuilder = () => navigate('/builder')
       const handlePartnerView = () => navigate('/partnerview')
      const handlePurchaseOrderList = () => navigate('/purchaseorderlist')
      const handleInvoiceView = () => navigate('/invoiceview')
         const handleReport = () => navigate('/report');
       const handleParts = () => navigate('/parts');
           const handlePartGroup = () => navigate('/partgroup');
         const handleBuilders = () => navigate('/builders');
         const handleTraders = () => navigate('/traders');
        const handleGRN = () => navigate('/grn');
    
    
    
  return (

    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header at the Top */}
       <AppBar position="static" sx={{ backgroundColor: '#941B0C' }}>
      <Toolbar>
        {/* Left-aligned Dashboard Title */}
        <Typography variant="h6" noWrap component="div">
          Dashboard
        </Typography>

        {/* Spacer to push the name to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Right-aligned Name */}
        <Typography variant="h6" noWrap component="div">
          Welcome {name}
        </Typography>
      </Toolbar>
    </AppBar>

     <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <LeftDrawer
        handleDashboard={handleDashboard}
      handleProfile={handleProfile}
          handleRequestQuote={handleRequestQuote}
          handleQuoteList={handleQuoteList}
          handleOrders={handleOrders}
          handleTracker={handleTracker}
          handleDealer={handleDealer}
          handleDealers={handleDealers}
          handleSupplier={handleSupplier}
       handleSuppliers={handleSuppliers}
          handleManufacturer={handleManufacturer}
      handleManufacturers={handleManufacturers}
        handlePurchaseOrder={handlePurchaseOrder}
      handleSendEstimate={handleSendEstimate}
      handleEstimate={handleEstimate}
       handlePartner={handlePartner}
      handleInvoice={handleInvoice}
      handleTrader={handleTrader}
      handleBuilder={handleBuilder}
      handlePartnerView={handlePartnerView}
      handlePurchaseOrderList={handlePurchaseOrderList}
      handleInvoiceView={handleInvoiceView}
      handleReport={handleReport}
      handleParts={handleParts}
      handlePartGroup={handlePartGroup}
      handleTraders={handleTraders}
      handleBuilders={handleBuilders}
            handleGRN={handleGRN}
          userRoles={roles}
          userTypes={userTypes}
/>
    <div>
      <Typography variant="h5" gutterBottom>
        Purchase Order List
      </Typography>
      <Grid container spacing={2} style={{ marginBottom: '20px' }}>
        <Grid item xs={6}>
          <TextField
            label="Search PO Number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Filter by Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            fullWidth
            select
          >
            <MenuItem value="">All</MenuItem>
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <DataGrid
        rows={filteredOrders}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        getRowId={(row) => row.poUniqueId}
        autoHeight
        sortingOrder={['asc', 'desc']}
        disableSelectionOnClick
      />

      {/* Status Menu */}
      <Menu
        anchorEl={statusAnchorEl}
        open={Boolean(statusAnchorEl)}
        onClose={() => setStatusAnchorEl(null)}
      >
        {statusOptions.map((status) => (
          <MenuItem
            key={status.id}
            onClick={() => handleStatusUpdate(selectedOrderId, status.id)}
          >
            {status.statusName}
          </MenuItem>
        ))}
      </Menu>
    </div>
</Box>
</Box>
  );
};

export default PurchaseOrderList;
